/**
 * A8.net JSトラッキング
 * 内容：
 * A8.netのアフィリエイトプログラムを利用するためにコンバージョンページへ指定のスクリプトタグを設定する。
 * スクリプトタグは、appendChildで動的に追加している。もっと良い方法があれば修正する。
 * タグ残り続けるとコンソールから操作できてしまう可能性があるので、a8sales()実行後は消している。
 * 前提：
 * クリック識別子のCookie保存は、DNS方式を採用している。
 * トラッキング用のサブドメイン：a8cv.crowdlinks.jp
 * 注文番号(order_number)には、一意となるユーザーIDを設定する。
 * 参照：
 * JSトラッキング導入仕様書(https://document.a8.net/a8docs/a8-tracking/js-tracking/a8-js-tracking.html)
 */

export interface a8Param {
  pid: string
  // eslint-disable-next-line camelcase
  order_number: string | undefined
  currency: string | undefined
  items: Array<a8Item>
  // eslint-disable-next-line camelcase
  total_price: number | undefined
  repeat?: string | undefined
  // eslint-disable-next-line camelcase
  amount_priority?: string | undefined
  coupon?: string | undefined
}

interface a8Item {
  code: string | undefined
  price: number
  quantity: number
}

const src = "https://statics.a8.net/a8sales/a8sales.js"

const className = "a8sales"

export function appendA8salesTag(params: a8Param) {
  // 本番環境以外では処理を実行しないようにここで中断する。
  if (process.env.APP_ENV !== "production") {
    return
  }
  appendA8salesSpan()
  appendA8salesScript(params)
}

/**
 * body内にspanタグを追加。
 */
function appendA8salesSpan() {
  const span = document.createElement("span")
  span.setAttribute("id", className)
  span.setAttribute("class", className)
  document.body.appendChild(span)
}

/**
 * body内にscriptタグを追加。
 */
function appendA8salesScript(params: a8Param) {
  const script = document.createElement("script")
  script.setAttribute("src", src)
  script.setAttribute("class", className)
  document.body.appendChild(script).onload = () => {
    callA8sales(params)
  }
}

/**
 * body内にscriptタグを追加。
 * 追加のタイミングでa8sales()が実行される。
 */
function callA8sales(params: a8Param) {
  const script = document.createElement("script")
  script.setAttribute("class", className)
  script.innerHTML = `a8sales(${JSON.stringify(params)})`
  document.body.appendChild(script)
  removeA8salesTag()
}

/**
 * a8salesに関連するタグを削除。
 */
function removeA8salesTag() {
  const a8sales = document.body.getElementsByClassName(className)
  while (a8sales.length) {
    a8sales.item(0)?.remove()
  }
}

/**
 * 注文番号を生成する。（MAX50byte）
 * 接頭語-タイムスタンプ(エポックミリ秒)-乱数(4桁)
 */
export function makeOrderNumber(prefixString: string): string {
  const prefix =
    prefixString.length > 31 ? prefixString.substring(0, 31) : prefixString
  const timestamp = Date.now().toString()
  const random = [...Array(4)].map(() => Math.floor(Math.random() * 10))
  return prefix + "-" + timestamp + "-" + random.join("")
}
